export const AgreementPdfResources = {
    es: {
        ['agreement']: 'Contrato',
        ['email']: 'Correo',
        ['signed_agreement']: 'Contrato Firmado',
        ['read_terms_and_conditions']: 'Lee tu contrato, en él se establece todos los terminos y condiciones. Fírmalo con tu firma autógrafa para finalizar tu renta',
        ['send_copy_to']: 'Enviar copia del contrato a',
    },
    en: {
        ['agreement']: 'Agreement',
        ['email']: 'Email',
        ['signed_agreement']: 'Signed Agreement',
        ['read_terms_and_conditions']: 'Read your contract, it sets out all the terms and conditions. Sign it with your handwritten signature to finalize your rental.',
        ['send_copy_to']: 'Send a copy of the agreement to',
    }
}
